module.exports = __webpack_public_path__ + "static/media/video-poster.4b583414.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/video-poster.png
 ** module id = 370
 ** module chunks = 0
 **/